// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"icon-wrapper_3pYdm","tips":"tips_3VqDa","show":"show_YTB1a"};